/* ---------------------------------------------------------------------------
 * Javascript Entry point
 * --------------------------------------------------------------------------- */
import $ from 'jquery';
window.$ = window.jQuery = $;
require('@fancyapps/fancybox');

/**
 * Sbtouch page application
 * @void
 */
let Application = function () {
    /**
     * Scope variable
     * @type {[object]}
     */
    let self = this;

    /**
     * Init Elements
     * {_context}
     * {_body}
     * {_header}
     * {_hamburger}
     * {_fancybox}
     */
    self._context = $(document);
    self._body = $('body', self._context);
    self._header = $('.component-header', self._context);
    self._hamburger = $('.hamburger', self._context);
    self._fancybox = $('.fancybox-youtube', self._context);
    self._behavior = $('.fancybox-youtube', self._context);
    self._dataGTM = $('[data-gtm]', self._context);

    /**
     * Initialize application
     * @void
     */
    self.initialize = () => {
        console.log('Init Seabird touch');

        /**
         * Initialize all functions
         */
        self.initFancybox();
        self.mobileNav();
        self.scrollNav();
        self.anchorScroll();
        self.gtmEvent();
    };

    /**
     * Initialize fancybox video
     * @void
     */
    self.initFancybox = () => {
        let options = {
            toolbar: true,
            animationEffect: 'zoom-in-out',
            transitionEffect: 'tub',
            youtube: {
                showinfo: 0,
                vq: 'hd720'
            },
            buttons: ['thumbs', 'close'],
            beforeShow: () => {
                $('.fancybox-caption-wrap').removeClass('fancybox-caption-wrap-visible');
            },
            afterShow: (_instance, _current) => {
                self.fancyboxCaption(_instance, _current);
                $(window).on('resize', () => {
                    self.fancyboxCaption(_instance, _current);
                });
            }
        };

        self._fancybox.fancybox(options);
    };

    /**
     * Calculate fancybox caption
     * @param  {[object)} instance [fancybox instance]
     * @param  {[object]} current  [current fancybox]
     * @void
     */
    self.fancyboxCaption = (instance, current) => {
        if (current.opts.caption) {
            let myCaptionWrap = $('.fancybox-caption-wrap');

            if ($(current.$slide).hasClass('fancybox-slide--complete')) {
                $(current.$slide)
                    .closest('.fancybox-inner')
                    .find('.fancybox-caption-wrap')
                    .addClass('fancybox-caption-wrap-visible');
            } else {
                $(current.$slide)
                    .closest('.fancybox-inner')
                    .find('.fancybox-caption-wrap')
                    .removeClass('fancybox-caption-wrap-visible');
            }

            let myImageWidth = $(current.$slide)
                .find($('.fancybox-image-wrap'))
                .width();

            let myImagePositionBottom = $(current.$slide)
                .find($('.fancybox-image-wrap'))
                .position().top +
                $(current.$slide)
                    .find($('.fancybox-image-wrap'))
                    .height();

            let myCaptionPosition = myImagePositionBottom - myCaptionWrap.innerHeight();

            myCaptionWrap.css('width', myImageWidth + 'px');
            myCaptionWrap.css('top', myCaptionPosition + 'px');
        }
    };

    /**
     * Toggle mobile navigation on click
     * @return {[type]} [description]
     */
    self.mobileNav = () => {
        self._hamburger.stop().on('click', (_event) => {
            _event.preventDefault();
            _event.stopPropagation();

            self._body.toggleClass('menu-opened');

            $('.nav-main').animate({ scrollTop: 0 }, 50);
        });
    };

    /**
     * Add class on document scroll
     * @void
     */
    self.scrollNav = () => {
        $(window).on('scroll load', () => {
            if ($(window).scrollTop() > 0) {
                self._header.addClass('scrolling');
            } else {
                self._header.removeClass('scrolling');
            }
        });
    };

    /**
     * Anchor smooth scroll
     * @void
     */
    self.anchorScroll = () => {
        $('a[href^="#"]')
            .not('[href="#"]')
            .not('[href="/#"]')
            .not('[href="#0"]')
            .on('click', (_event) => {
                if (event.currentTarget.hash !== '') {
                    _event.preventDefault();

                    self._body.removeClass('menu-opened');

                    // Store hash
                    let hash = _event.currentTarget.hash;

                    $('html, body').animate({ scrollTop: $(hash).offset().top }, 500, () => {
                        window.location.href.split('#')[0];
                    });
                }
            });
    };

    /**
     * Google tag manager
     * @void
     */
    self.gtmEvent = () => {
        self._dataGTM.each((_index, _el) => {
            let label = $(_el).data('gtm');

            let category = label.includes('LP_') ? 'bouton' : 'video';

            $(_el).on('click', () => {
                // GTM event
                ga('gtm1.send', 'event', category, 'click', label);
            });
        });
    };
};

/**
 * Jquery Document ready
 */
$(() => {
    let app = new Application() || {};

    app.initialize();
});
